const rechargeElement = document.querySelector(".recharge-subscription-widget");

const config = { 
  attributes: true, 
  childList: true, 
  subtree: true 
};

if (rechargeElement) {
  const callback = (mutationsList, observer) => {
    let widget;
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        widget = mutation.target.querySelector('.subscription-radio');
        const toolTip = mutation.target.querySelector('.rc-tooltip__footer');
        if (toolTip) {
          toolTip.style.display = "none";
        }
      }
    });

    if (widget) {
      let rechargeBulletpoints = window.recharge_bulletpoints;
      let checkForExistingBulletpoints = document.querySelector('.recharge-bulletpoints');
      let rechargeWrapper = document.createElement('div');
      rechargeWrapper.setAttribute('class', 'recharge-bulletpoints');

      if (rechargeBulletpoints && !checkForExistingBulletpoints) {
        widget.appendChild(rechargeWrapper);
        rechargeWrapper.innerHTML = window.recharge_bulletpoints;
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(rechargeElement, config);
}